import * as React from 'react';

interface LoaderProps {
  withoutText?: boolean;
  className?: string;
}
export const Loader: React.FC<LoaderProps> = ({ withoutText, className }): JSX.Element => {
  return (
    <div className={`d-flex align-items-baseline ${withoutText ? 'mt-3' : ''} ${className}`}>
      <div className="blinker" title="Loading"></div>
      <span className="ms-2 fw-light fs-6">{withoutText ? '' : 'Loading'}</span>
    </div>
  );
};
